import { createSelector } from 'reselect';
import { maybe } from '@/utils';
import currentSessionSelector from './session';

export default createSelector(currentSessionSelector, (currentSession) => {
  return {
    hasResourceLimitExceeded: maybe(currentSession, 'hasResourceLimitExceeded'),
  };
});
